<template>
  <div class="common">
    <search-form :formConfig="formConfig" :source="searchData" @handleSearchJsf="handleSearchJsf"
      @handleSearchZff="handleSearchZff" @handleSearchCst="handleSearchCst" @handleSearchManager="handleSearchManager"
      @search="search">
      <template slot="btns" v-if="tabType == 'review'">
        <a-button @click="showModal(1)" :loading="checkLoad" class="search-btn-item" type="primary"
          :disabled="!selectedRowKeys.length">同意</a-button>
        <a-button @click="showModal(2)" :loading="checkLoadCancel" class="search-btn-item btn-blue-line"
          :disabled="!selectedRowKeys.length">拒绝</a-button>
      </template>
      <template slot="btns" v-if="tabType == 'records'">
        <a-button :loading="checkLoad" class="search-btn-item" type="primary" @click="onExport">导出</a-button>
      </template>
    </search-form>

    <div class="table-common">
      <div class="table-check-bar" v-if="selectedRows.length">
        已选择：
        <span class="text-color-blue">{{ selectedRows.length }} 条</span>
        祺信面额：
        <span class="text-color-orange">{{ totalPayable(selectedRows) | splitK }} 元</span>
      </div>
      <a-table size="middle" :columns="columns" :data-source="tableData" :pagination="pagination" :loading="loading"
        :row-key="(record, index) => record.id + '_' + record.createTime" @change="handleTableChange" bordered
        :scroll="columns.length > 10 ? { x: '100%' } : {}" :locale="{ emptyText: '暂无数据' }" :row-selection="tableSelect">
        <template slot="guaranteeName" slot-scope="text,record">
          <span v-if="record.guaranteeName">
            {{ record.guaranteeName }}
          </span>
          <span v-else>--</span>
        </template>
        <template slot="gldAmt" slot-scope="text">{{ text | splitK }}</template>
        <template slot="exDay" slot-scope="text">{{
          text | dateFormat("YYYY-mm-dd")
        }}</template>
        <template slot="aplyDay" slot-scope="text">{{
          text | dateFormat("YYYY-mm-dd")
        }}</template>
        <template slot="canBeModified" slot-scope="text">{{
          text | gbCbmTrans
        }}</template>
        <template slot="operation" slot-scope="text, record">
          <a @click="toPageDetail(record)">详情</a>
        </template>
      </a-table>
      <div :class="{
        'table-total': pagination.total > 0,
        'table-total-none': pagination.total == 0,
      }">
        共有记录：
        <span class="text-color-blue">{{ pagination.total }} 条</span>祺信面额：
        <span class="text-color-orange">{{ totalPayable(tableData) | splitK }} 元</span>
      </div>
    </div>
    <a-modal width="400px" :title="modalTitle" :visible="modalShow" :maskClosable="false" :footer="null"
      @cancel="modalShow = false">
      <exdate-change-password-modal v-if="modalShow" :modalData="modalData" @ok="modalOk"
        @cancel="modalCancel"></exdate-change-password-modal>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { selectTenant } from "@/api/login.js";
import { modifiedPage, findModifiedReviewRcptyOrManager,modifiedPageExport } from "@/api/review.js";
import { existOnTheWay } from "@/api/gold.js";
import exdateChangePasswordModal from "@/pages/review/exdate-change/exdate-change-password-modal";
export default {
  props: {
    tabType: {
      type: [String],
      required: false,
      default: function () {
        return ""; //所属tab的分类
      },
    },
    status: {
      type: [String],
      required: false,
      default: function () {
        return "";
      },
    },
  },
  name: "exdate-change-main",
  components: {
    exdateChangePasswordModal,
  },
  data() {
    return {
      searchData: {
        aplyDay: [],
        gldId: "",
        receiver: {},
        exDay: [],
        oriExDay: [],
        tenantId: {},
        manager: {},
        status: [],
      },
      formConfig: [
        {
          prop: "aplyDay",
          type: "dateRange",
          label: "申请日期",
        },
        {
          prop: "gldId",
          type: "input",
          label: "祺信编号",
        },
        {
          prop: "receiver",
          type: "selectSearch",
          label: "接收方",
          option: [],
          searchSource: true,
          headNameFirst: "开立方名称",
          headNameSecond: "社会信用代码",
          valuePorp: "orgCode",
          valuePorpReal: "cstId",
          labelPorp: "cstNm",
          searchHandle: "handleSearchJsf",
        },
        {
          prop: "exDay",
          type: "dateRange",
          label: "到期日期",
        },
        {
          prop: "oriExDay",
          type: "dateRange",
          label: "原到期日期",
        },
        // {
        //     prop: "tenantId",
        //     type: "selectSearch",
        //     label: "保理商",
        //     option: [],
        //     searchSource: true,
        //     valuePorp: "tenantId",
        //     labelPorp: "tenantName",
        //     normal:true,
        //     searchHandle: "handleSearchCst",
        // },
        {
          prop: "manager",
          type: "selectSearch",
          label: "经办员",
          option: [],
          searchSource: true,
          valuePorp: "managerIdCardNum",
          valuePorpReal: "manager",
          labelPorp: "managerName",
          headNameFirst: "经办人名称",
          headNameSecond: "身份证号",
          searchHandle: "handleSearchManager",
        },
        {
          prop: "status",
          type: "select",
          label: "状态",
          hide: this.tabType == "review",
          mode: 'multiple',
          option: [
            { name: "已同意", value: "1" },
            { name: "已拒绝", value: "2" },
          ],
          defaultProps: {
            value: "value",
            label: "name",
          },
        },
      ],
      columns: [
        {
          title: "申请日期",
          sorter: true,
          dataIndex: "aplyDay",
          scopedSlots: { customRender: "aplyDay" },
        },
        {
          title: "祺信编号",
          dataIndex: "gldId",
          sorter: true,
        },
        {
          title: "开立方",
          dataIndex: "estbNm",
          sorter: true
        },
        {
          title: "担保方",
          dataIndex: "guaranteeName",
          sorter: true,
          scopedSlots: { customRender: "guaranteeName" },
        },
        {
          title: "接收方",
          dataIndex: "rcPtyNm",
          sorter: true
        },
        {
          title: "祺信面额(元)",
          dataIndex: "gldAmt",
          sorter: true,
          scopedSlots: { customRender: "gldAmt" },
        },
        {
          title: "到期日期",
          sorter: true,
          dataIndex: "exDay",
          scopedSlots: { customRender: "exDay" },
        },
        // {
        //     title: "保理商",
        //     dataIndex: "tenantName",
        //     width:"120px"
        // },
        {
          title: "变更状态",
          dataIndex: "canBeModified",
          scopedSlots: { customRender: "canBeModified" },
        },
        {
          title: "经办员",
          dataIndex: "managerName",
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      tableData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        sortField: "",
        sortOrder: "",
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ["5", "10", "20", "50", "100"],
        showTotal: (total) => {
          return `共 ${total} 条`;
        },
      },
      loading: false,
      selectedRows: [],
      selectedRowKeys: [],
      checkLoad: false,
      checkLoadCancel: false,
      modalShow: false,
      modalData: {},
      modalTitle: "变更复核-同意",
      tableDataAllPage: [],
    };
  },
  computed: {
    ...mapGetters({
      userObj: "home/getUserObj",
    }),
    tableSelect() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        selectedRows: this.selectedRows,
        onChange: this.onTableChange,
        type: "radio",
        // getCheckboxProps: record => ({
        //     props: {
        //         disabled: record.canBeModified == '3' // Column configuration not to be checked
        //     }
        // })
      };
    },
  },
  methods: {
     onExport() {
       // 字段映射：前端dataIndex到后端字段
       const fieldMapping = {
         'aplyDay': 'aplyDay',
         'gldAmt': 'gldAmt',
         'exDay': 'exDay',
         'estbNm': 'estbNm',
         'guaranteeName': 'guaranteeName',
         'rcPtyNm': 'rcPtyNm'
       };
       
       let orderBy = "";
       if (this.pagination.sortField) {
         const dbField = fieldMapping[this.pagination.sortField] || this.pagination.sortField;
         const order = this.pagination.sortOrder == "ascend" ? "asc" : "desc";
         orderBy = `${dbField} ${order}`;
       }
       
       const params = {
         orderBy: orderBy,
         status: (this.searchData.status && this.searchData.status.length > 0) ? this.searchData.status.join(',') : this.status,

         manager: this.searchData.manager.key,

         gldId: this.searchData.gldId,
         rcPty: this.searchData.receiver.key,
         tenantId: this.searchData.tenantId.key,
         aplyDayStart: this.searchData.aplyDay[0],
         aplyDayEnd: this.searchData.aplyDay[1],
         exDayStart: this.searchData.exDay[0],
         exDayEnd: this.searchData.exDay[1],
         oriExDayStart: this.searchData.oriExDay[0],
         oriExDayEnd: this.searchData.oriExDay[1],
       };
      modifiedPageExport(params)
        .then((res) => {
          this.utils.fileDownload(res, `复核记录_${new Date().getTime()}.xls`);
        })
        .catch((err) => {
           this.$message.error("导出失败");
        });
    },
    handleSearchJsf(value, data, cfg) {
      const cstIds = this.userObj.cstIds.join(",");
      let param = {
        queryType: 1,
      };
      this.getDataList(value, param, cfg);
    },
    handleSearchZff(value, data, cfg) {
      const cstIds = this.userObj.cstIds.join(",");
      let param = {
        queryType: 2,
      };
      this.getDataList(value, param, cfg);
    },
    getDataList(value, param = {}, cfg) {
      //下拉筛选
      const cstIds = this.userObj.cstIds.join(",");
      findModifiedReviewRcptyOrManager({
        cstNm: value,
        pageNum: 1,
        pageSize: 10,
        status: 0,
        queryType: 0,
      })
        .then((res) => {
          const index = this.formConfig.findIndex((item) => item.prop == cfg.prop);
          if (res.data && res.data.grid) {
            this.formConfig[index].option = res.data.grid.list || [];
          } else {
            this.formConfig[index].option = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSearchCst(value, data, cfg) {
      this.getDataListTenant(value, cfg);
    },
    getDataListTenant(value, cfg) {
      //下拉筛选
      selectTenant({
        tenantName: value,
        pageSize: 10,
        tenantName: value || "",
        pageNum: 1,
      })
        .then((res) => {
          const index = this.formConfig.findIndex((item) => item.prop == cfg.prop);
          if (res.data && res.data.grid) {
            this.formConfig[index].option = res.data.grid.list || [];
          } else {
            this.formConfig[index].option = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleSearchManager(value, data, cfg) {
      findModifiedReviewRcptyOrManager({
        pageNum: 1,
        pageSize: 10,
        status: 0,
        queryType: 1,
        managerName: value,
      })
        .then((res) => {
          const index = this.formConfig.findIndex((item) => item.prop == cfg.prop);
          if (res.data && res.data.grid) {
            this.formConfig[index].option = res.data.grid.list || [];
          } else {
            this.formConfig[index].option = [];
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    search(data) {
      this.searchData = data || this.searchData;
      this.getTableData();
    },
    getTableData() {
      this.loading = true;
      const today = this.utils.dateFormat(new Date(), "yyyy-MM-dd");
      // 字段映射：前端dataIndex到后端字段
      const fieldMapping = {
        'aplyDay': 'aplyDay',
        'gldAmt': 'gldAmt',
        'exDay': 'exDay',
        'estbNm': 'estbNm',
        'guaranteeName': 'guaranteeName',
        'rcPtyNm': 'rcPtyNm'
      };
      
      let orderBy = "";
      if (this.pagination.sortField) {
        const dbField = fieldMapping[this.pagination.sortField] || this.pagination.sortField;
        const order = this.pagination.sortOrder == "ascend" ? "asc" : "desc";
        orderBy = `${dbField} ${order}`;
      }
      
      const params = {
        orderBy: orderBy,
        status: (this.searchData.status && this.searchData.status.length > 0) ? this.searchData.status.join(',') : this.status,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        manager: this.searchData.manager.key,

        gldId: this.searchData.gldId,
        rcPty: this.searchData.receiver.key,
        tenantId: this.searchData.tenantId.key,
        aplyDayStart: this.searchData.aplyDay[0],
        aplyDayEnd: this.searchData.aplyDay[1],
        exDayStart: this.searchData.exDay[0],
        exDayEnd: this.searchData.exDay[1],
        oriExDayStart: this.searchData.oriExDay[0],
        oriExDayEnd: this.searchData.oriExDay[1],
      };
      modifiedPage(params)
        .then((res) => {
          this.loading = false;
          this.pagination.total = res.data.grid.total;
          this.tableData = res.data.grid.list;
          this.renderTableAllPage();
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
        });
    },
    totalPayable(list = [], prop = "gldAmt") {
      return list.reduce((acc, rec) => {
        return acc + (+rec[prop] || 0);
      }, 0);
    },
    handleTableChange(pagination, filters, sorter) {
      //表格排序回调
      this.pagination = {
        current: pagination.current,
        pageSize: pagination.pageSize,
        sortField: sorter.field,
        sortOrder: sorter.order,
        total: this.pagination.total || 0,
      };
      this.getTableData();
    },
    onTableChange(selectedRows, data, data2) {
      //表格选择回调
      this.selectedRowKeys = selectedRows;
      this.selectedRows = this.tableDataAllPage.filter(
        (item) => selectedRows.indexOf(item.id + "_" + item.createTime) > -1
      );
    },
    renderTableAllPage() {
      //记录加载的数据，用于记录选中的表格数据
      this.tableData.forEach((i) => {
        let flag = this.tableDataAllPage.find(
          (item) => item.id == i.id && item.createTime == i.createTime
        );
        let idList = this.tableDataAllPage.map((i) => i.id);
        if (!flag && idList.indexOf(i.id) == -1) {
          this.tableDataAllPage.push(i);
        }
      });
    },
    handleChangeTag(tag, checked) {
      this.selectedTag = tag.value;
    },
    getCircleList(value) {
      this.selectTenant(value);
    },
    selectTenant(value) {
      //下拉筛选
      selectTenant({
        pageSize: 10,
        tenantName: value || "",
        pageNum: 1,
      })
        .then((res) => {
          this.recPersonList = res.data.grid.list;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    toPageDetail(data) {
      let way = "buyer";
      this.MENUAPI.goToOneTab({
        path: "bill-payment/payment/detail/" + way + "/" + data.gldId + "/3",
      });
    },
    showModal(type) {
      if (!this.selectedRows.length) {
        this.$message.warn("请至少选择一条数据");
        return;
      }
      this.modalData = {
        gldIds: this.selectedRows.map((i) => i.gldId) || [],
        status: type,
        exDay: this.selectedRows[0].exDay,
        oriExDay: this.selectedRows[0].oriExDay,
      };
      this.modalTitle = "变更复核-" + (type == 2 ? "拒绝" : "同意");
      let that = this;
      if (type == 1) {
        existOnTheWay(this.selectedRows[0].gldId).then((res) => {
          if (res.data) {
            this.$info({
              title: "存在在途子祺信，变更还款日期会将在途祺信全部撤回。",
              okText: "确认",
              onOk() {
                that.modalShow = true;
              },
            });
          } else {
            this.modalShow = true;
          }
        });
      } else {
        this.modalShow = true;
      }
    },
    modalOk() {
      this.modalShow = false;
      this.refresh();
    },
    modalCancel() {
      this.modalShow = false;
      this.refresh();
    },
    refresh() {
      this.tableDataAllPage = [];
      this.selectedRows = [];
      this.selectedRowKeys = [];
      this.getTableData();
      this.$store.dispatch("home/getMessageCount");
    },
  },
  created() {
    this.formConfig = this.formConfig.filter((i) => !i.hide);
    if (!this.pagination.sortField) {
      this.pagination.sortField = "aplyDay";
      this.pagination.sortOrder = "descend";
    }
    this.getTableData();
  },
  mounted() { },
  activated() { },
};
</script>
<style scoped>
.input-content>div {
  margin: 10px 20px 20px 0;
}

.common /deep/ .search-item-lable {
  min-width: 85px;
}
</style>



// WEBPACK FOOTER //
// src/pages/review/exdate-change/exdate-change-main.vue